<!--  -->
<template>
  <div class="btn">
    <img src="http://img.wish.hebyun.com.cn/images/update_bg.png" />
    <span>{{ button }}</span>
  </div>
</template>

<script>
export default {
  props: ["button"],
};
</script>
<style lang="scss">
.btn {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 300px;
  height: 42px;
  margin: 50px auto 10px;
  img {
    width: 100%;
    height: 100%;
    background-image: linear-gradient(0deg, #e10019 0%, #f5531a 100%);
    box-shadow: 0px 1.5px 6px 0px rgba(203, 10, 8, 0.26);
    border-radius: 40px;
  }
  span {
    position: absolute;
    font-size: 18px;
    color: #f8f3cd;
  }
}
</style>
